import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

/**
 * Copy icon — used by the "Save as…" action button.
 */
export const Copy = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fass', 'copy']}
      {...props}
    />
  );
};
